require('slick-carousel');
const moreBookingsCarousel = require('../../components/moreBookingsCarousel').moreBookingsCarousel;

featuresPromoSlider = () => {
  let sliderWrapper = $('.js-features-slider');

    sliderWrapper.slick({
        slidesToShow: 1,
        dots: true,
        arrows: false,
        autoplay: true,
        duration: 2000,
    });
};

new moreBookingsCarousel();
featuresPromoSlider();
